// @flow
import { createStore, combineReducers, applyMiddleware, compose } from "redux"
import { reducer as formReducer } from "redux-form"
import { reducer as networkReducer } from "../Network"
import { routerReducer, routerMiddleware } from "react-router-redux"
import { reducer as intlReducer } from "../Intl"
import { reducer as modalReducer } from "../Modal"
import { reducer as kioskReducer } from "../Kiosk"
import { reducer as fixedResolutionReducer } from "../Kiosk/FixedResolutionContainer"
import { client } from "../API"
import createHistory from "history/createBrowserHistory"
import protectedMiddleware from "./protectedMiddleware"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const rootReducer = combineReducers({
  network: networkReducer,
  form: formReducer,
  routing: routerReducer,
  intl: intlReducer,
  modal: modalReducer,
  kiosk: kioskReducer,
  fixedResolution: fixedResolutionReducer,
  apollo: client.reducer()
})

const history = createHistory()

const middlewares = applyMiddleware(
  protectedMiddleware,
  routerMiddleware(history),
  client.middleware()
)

const store: Function = createStore(
  rootReducer,
  {},
  composeEnhancers(middlewares)
)

export { store, history }



// WEBPACK FOOTER //
// ./src/config/store.js